import { Component, OnInit, Input, ViewChild, ElementRef, ViewEncapsulation } from '@angular/core';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as wNumb from 'wnumb';
import { NgForm } from '@angular/forms';
import { NouisliderComponent } from 'ng2-nouislider';

@Component({
  selector: 'app-calculated-result',
  templateUrl: './calculated-result.component.html',
  styleUrls: ['./calculated-result.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CalculatedResultComponent implements OnInit {
  @ViewChild("emislider", {static:false}) mSliderComp:NouisliderComponent;
  @ViewChild("emislider", { read: ElementRef, static:false }) mSliderEl: ElementRef;

  @Input() public formData;

  constructor(private modalService: NgbModal,public activeModal: NgbActiveModal) { }
  result;
  emiCalculator;
  loanInterestRate:number = 8.25;
  loanPeriod:number = 10;
  emi:object;

  ngOnInit() {
    console.log('formData',this.formData);
    this.result = this.formData;
    this.emiCalculator = {
      'plantCost':3499,
      'subsidy':70,
      'debtEquityRatio':{'first':30,'second':70},
      'downPayment':184800,
      'loanAmount':79200,
      'loanInterestRate':this.loanInterestRate,
      'loanPeriod':this.loanPeriod
    }
  }

  close() {
    this.activeModal.close();
  }

  updateInterestRate(rate){
    this.loanInterestRate = rate;
  }

  updateLoanPeriod(period){
    this.loanPeriod = period;
  }

  loanInterestConfig: any = {
    connect: [true,false],
    start: this.loanInterestRate,
    step: 0.25,
    range: {
      min: 5,
      max: 20
    },
    pips: {mode: 'count', values: 5},
    tooltips:true,
    format: wNumb({
      decimals: 2
    })
  };

  loanPeriodConfig: any = {
    connect: [true,false],
    start: this.loanPeriod,
    step: 1,
    range: {
      min: 1,
      max: 30
    },
    pips: {mode: 'count', values: 5},
    tooltips:true,
    format: wNumb({
      decimals: 0
    })
  };

  calculate(form:NgForm){
    console.log('emi form',form.value);
    this.emi = form.value;
  }

}
